function outerHeight( el ) {
  let height = el.offsetHeight;
  let style = getComputedStyle( el );
  height += parseInt( style.marginTop ) + parseInt( style.marginBottom );
  return height;
}

function outerWidth( el ) {
  let width = el.getBoundingClientRect().width;
  let style = getComputedStyle( el );
  width += parseInt( style.marginLeft ) + parseInt( style.marginRight );
  return width;
}

function setTargetWidthToSourceWidth( targetId, sourceId ) {
  const source = document.getElementById( sourceId );
  const target = document.getElementById( targetId );
  if ( ! target || ! source ) return;
  const sourceHeight = outerWidth( source );
  target.style.width = sourceHeight + 'px';
}

function setXMarginBasedOnTwoSources( targetId, targetStartId, targetEndId ) {
  const target = document.getElementById( targetId );
  const targetStart = document.getElementById( targetStartId );
  const targetEnd = document.getElementById( targetEndId );
  if ( ! target || ! targetStart || ! targetEnd ) return;
  const targetStartWidth = outerWidth( targetStart );
  const targetEndWidth = outerWidth( targetEnd );
  target.style.paddingLeft = targetStartWidth + 'px';
  target.style.paddingRight = targetEndWidth + 'px';
}

function setEndMarginBasedOnOneSource( targetId, sourceEndId ) {
  const target = document.getElementById( targetId );
  const targetEnd = document.getElementById( sourceEndId );
  if ( ! target || ! targetEnd ) return;
  const targetEndWidth = outerWidth( targetEnd );
  target.style.paddingRight = targetEndWidth + 'px';
}

const setRootVarHeightEmpty = ( targetId ) => {
  document.documentElement.style.setProperty( targetId, `0px` );
};
const setRootVarFromElementHeight = ( targetId, target ) => {
  if ( ! target ) return;
  const height = outerHeight( target );
  document.documentElement.style.setProperty( targetId, `${ height }px` );
};
const setRootVarFromElementWidth = ( targetId, target ) => {
  if ( ! target ) return;
  const width = outerWidth( target );
  document.documentElement.style.setProperty( targetId, `${ width }px` );
};

const setRootVarFromElementIdHeight = ( targetId, sourceId ) => {
  const target = document.getElementById( sourceId );
  // if ( ! target ) return;
  if ( ! target ) setRootVarHeightEmpty(targetId);
  setRootVarFromElementHeight( targetId, target );
};

const setRootVarFromElementIdWidth = ( targetId, sourceId ) => {
  const target = document.getElementById( sourceId );
  if ( ! target ) return;
  setRootVarFromElementWidth( targetId, target );
};

export { setRootVarFromElementHeight,setRootVarFromElementWidth, setRootVarFromElementIdHeight, setRootVarFromElementIdWidth };
